import React from 'react';
import PropTypes from 'prop-types';

import "./ConnectWithFacebook.scss";
import { SuccessButton } from '../../../index';
import icon from '../../../assets/imgs/facebook-f.svg';

const ConnectWithFacebook = ({ onClick })=>{
  return(
    <SuccessButton
      onClick={onClick}
      background="#3b5998"
      style={{ width: '320px' }}
    >
      <div className="facebook">
        <img className='facebook__icon' src={icon} alt=""/>
        <span className='facebook__title'>FACEBOOK CONNECT</span>
      </div>
    </SuccessButton>
  )
};

ConnectWithFacebook.propTypes = {
  onClick: PropTypes.func
};

ConnectWithFacebook.defaultProps = {
  onClick: ()=> {}
}

export default ConnectWithFacebook;
